import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row, Form, Modal } from "reactstrap";
import Select from "react-select";
import axios from "axios";
import AccessDeniedPopup from "components/Common/AccessDeniedPopup";
import configure from "configure";
import Swal from "sweetalert2";
import Loader from "components/Common/Loader";

// editor
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  assingOptions,
  cityOptions,
  colourStyles,
  countryOptions,
  locationOptions,
  stateOptions,
  statusOptions,
} from "common/utils/ComonOptions";
import secureLocalStorage from "react-secure-storage";
import { type } from "utils/common-options";

const EditLead = ({ id, LeadStatus, setmodal_fullscreen1, fetch }) => {
  const [fixButtons, setFixButtons] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formRows, setFormRows] = useState([{}]);
  const [status, setStatus] = useState([]);
  const [company_name, setCompany_name] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState();
  const [state, setState] = useState(null);
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPinCode] = useState("");
  const [description, setDescription] = useState("");
  // const [person_details, setPerson_details] = useState("")
  const [country_option, setCountry_option] = useState([]);
  const [state_option, setState_option] = useState([]);
  const [city_option, setCity_option] = useState([]);
  const [source, setSource] = useState([])
  const [source_name, setSourceName] = useState([])
  const [source_option, setSourceOption] = useState([])
  const [source_dependent, setSourceDependent] = useState(false)
  const [lead_type, setLead_type] = useState([])

  const [error, setError] = useState(null);
  const [auth_id, setAuth_id] = useState(null);

  const navigate = useNavigate(-1);

  useEffect(() => {
    const authUser = secureLocalStorage.getItem("User");
    setAuth_id(authUser.uid);

    FetchEditLead();
  }, []);

  const getCustmerData = async (e) => {
    setLoading(true);
    try {
      const authUser = secureLocalStorage.getItem("Token");
      const resp = await axios({
        method: "get",
        url: `${configure.apiUrl}/customers`,
        headers: {
          Authorization: `Bearer ${authUser}`,
        },
      }).then((res) => {
        setSourceDependent({ label: e.label, list: res.data.customers })
        setLoading(false);
      });
    } catch (error) {
      console.log("Customer Data Error", error);
      setLoading(false);
    }
  };

  const FetchEditLead = async () => {
    setLoading(true);
    const token = secureLocalStorage.getItem("Token");
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/leads/${id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(async (response) => {
        const data = response.data.lead;

        setCompany_name(data.company ? data.company : " - ");
        setWebsite(data.website ? data.website : " - ");
        setEmail(data.email ? data.email : " - ");
        setPhone(data.phonenumber ? data.phonenumber : " - ");
        setAddress(data.address ? data.address : " - ");
        setPinCode(data.zip ? data.zip : " - ");
        setDescription(data.description ? data.description : " - ");
        setFormRows(JSON.parse(data.person_details));
        setStatus(LeadStatus.filter((item) => item?.value == data.status)[0]);
        setLead_type(type?.find((obj) => obj?.label == data?.lead_type))

        const fromData = new FormData()
        fromData.append("country_id", 1)
        await axios({
          method: "post",
          url: `${configure.api}/lead_belong`,
          data: fromData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }).then((ress) => {
          const sources = ress.data.data.lead_source?.filter((obj) => obj?.leadname?.toLowerCase() != 'introducer').map(item => ({
            value: item.id,
            label: item.leadname,
          }))
          console.log(sources, data)
          const sourceSelect = sources?.find(obj => obj.value == data?.source)
          setSource(sources?.find(obj => obj.value == data?.source))
          setSourceOption(sources)
          if (sourceSelect?.label?.toLowerCase() == "customer") {
            getCustmerData({ label: sourceSelect?.label })
          }
        })

        // Get Country
        await axios({
          method: "get",
          url: `${configure.apiUrl}/all/countries`,
          headers: {
            Acceept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }).then((res2) => {
          const options = res2.data.countries?.map((obj) => ({
            label: obj.name,
            value: obj.id,
          }));
          setCountry_option(options);
          setCountry(options.filter((obj) => obj.value == data.country)[0]);
          setLoading(false);
        });

        // Get State
        await axios({
          method: "post",
          url: `${configure.apiUrl}/all/states`,
          data: {
            country_id: data.country,
          },
        }).then((res) => {
          setLoading(false);
          setState_option(
            res.data.states?.map((obj) => ({
              value: obj.id,
              label: obj.name,
            }))
          );

          setState(
            res.data.states
              ?.map((obj) => ({
                value: obj.id,
                label: obj.name,
              }))
              .filter((item) => item.value == data.state)[0]
          );
        });

        // Get City
        await axios({
          method: "post",
          url: `${configure.apiUrl}/all/cities`,
          data: {
            state_id: data?.state,
          },
        }).then((res) => {
          setLoading(false);
          setCity_option(
            res.data.cities?.map((obj) => ({
              value: obj.id,
              label: obj.name,
            }))
          );

          setCity(
            res.data.cities
              ?.map((obj) => ({
                value: obj.id,
                label: obj.name,
              }))
              .find((item) => item.value == data?.city)
          );
        });

        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      console.log("Error", error);
    }
  };

  const getState = async (e) => {
    setLoading(true);
    setCountry(e);
    setState([]);
    setCity([]);
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/all/states`,
        data: {
          country_id: e.value,
        },
      }).then((res) => {
        setLoading(false);
        setState_option(
          res.data.states?.map((obj) => ({
            value: obj.id,
            label: obj.name,
          }))
        );
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getCities = async (e) => {
    setLoading(true);
    setState(e);
    const formData = new FormData();
    formData.append("", e.value);
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/all/cities`,
        data: {
          state_id: e.value,
        },
      }).then((res) => {
        setLoading(false);
        setCity_option(
          res.data.cities?.map((obj) => ({
            value: obj.id,
            label: obj.name,
          }))
        );
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const saveEditLead = async (e) => {
    e.preventDefault();
    if (
      status.length != 0 &&
      country.length != 0 &&
      state.length != 0 &&
      description.length != 0
    ) {
      setLoading(true);
      const payload = {
        person_details: formRows,
        status: status.value,
        company: company_name,
        website,
        email,
        phonenumber: phone,
        country: country.value,
        address,
        zip: pincode,
        description,
        state: state.value,
        city: city?.value || "", // safe fallback
        source_name: source_name?.value,
        source: source?.value,
        lead_type:lead_type?.value
      };
      const token = secureLocalStorage.getItem("Token");

      try {
        const response = await axios({
          method: "put",
          url: `${configure.apiUrl}/leads/${id}`,
          data: payload,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }).then((res) => {
          setLoading(false);
          Swal.fire({
            icon: "success",
            text: "Lead Edited Successfully",
          }).then(data => {
            setmodal_fullscreen1(false);
            fetch()
          })
        });
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      setError(true);
      // console.log("ee")
    }
  };

  //code for adding the edited data
  const onPersonName = (e, key) => {
    const updatedArray = [...formRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setFormRows(updatedArray);
    //  console.log(persondetail)
  };
  const onPersonEmail = (e, key) => {
    const updatedArray = [...formRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setFormRows(updatedArray);
    //  console.log(persondetail)
  };
  const onPersonPhone = (e, key) => {
    const updatedArray = [...formRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setFormRows(updatedArray);
    //  console.log(persondetail)
  };

  const onPersonAuthority = (e, key) => {
    const updatedArray = [...formRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setFormRows(updatedArray);
    //  console.log(persondetail)
  };
  const onPersonPrimary = (e, key) => {
    const updatedArray = [...formRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setFormRows(updatedArray);
  };

  const onLinkedIn = (e, key) => {
    const updatedArray = [...formRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setFormRows(updatedArray);
  };
  const onFacebook = (e, key) => {
    const updatedArray = [...formRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setFormRows(updatedArray);
  };

  // dynamic form add
  const onAddFormRow = () => {
    setFormRows([...formRows, {}]);
  };

  const onDeleteFormRow = (index) => {
    const newInputs = [...formRows];
    newInputs.splice(index, 1);
    setFormRows(newInputs);
  };

  const options = [
    {
      value: "true",
      label: "Yes",
    },
    {
      value: "false",
      label: "No",
    },
  ];

  const options2 = [
    {
      value: "on",
      label: "Yes",
    },
    {
      value: "off",
      label: "No",
    },
  ];

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="">
        <Container fluid>
          <Row className="px-1">
            <Form>
              <div
                className={`flex-column fixed-buttons pt-2 ${fixButtons ? "d-flex" : "d-none"
                  }`}
              >
                <button
                  type="submit"
                  onClick={(e) => saveEditLead(e)}
                  className="btn btn-save fix-btn btn-label pe-0"
                >
                  <i className="fas fa-save me-2 label-icon"></i>
                  <span>Save</span>
                </button>
                <a
                  onClick={() => navigate(-1)}
                  className="btn btn-red  fix-btn  btn-label pe-0"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  <span>Cancel</span>
                </a>
              </div>
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="col-md-6 mb-3">
                  <h5 className="mb-3">Edit Lead Information</h5>
                </div>
                <div className="col-md-6 mb-3 text-end">
                  <button
                    type="submit"
                    onClick={(e) => saveEditLead(e)}
                    className=" btn ms-md-2 btn-save  btn-label"
                  >
                    <i className="fas fa-save me-1 label-icon"></i> save
                  </button>
                  {/* <a
                    onClick={(e) => {
                      navigate(-1);
                    }}
                    className=" btn ms-md-2 btn-red  btn-label "
                  >
                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                    CANCEL
                  </a> */}
                </div>

                {/* Lead Information  */}
                <div className="row">
                  <div className="col-md-3 mb-3">
                    <label htmlFor="">
                      Status <span className="text-danger">*</span>{" "}
                    </label>
                    <Select
                      value={status}
                      placeholder="Select Status"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={LeadStatus}
                      onChange={(e) => {
                        setStatus(e)
                      }}
                    />
                    <span
                      className="text-danger"
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        paddingTop: "7px",
                      }}
                    >
                      {(status?.length == 0) == error
                        ? "Please select Lead Status"
                        : null}
                    </span>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label htmlFor="">
                      Source
                    </label>
                    <Select
                      onChange={e => {
                        setSource(e)
                        if (e.label == "Customer") {
                          // getCustmerData(e)
                        } else {
                          setSourceDependent(false)
                        }
                      }}
                      placeholder="Select Source"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={source_option}
                      value={source}
                    />
                  </div>
                  {source_dependent && (
                    <div className="col-md-3 mb-3">
                      <label htmlFor="">
                        {source_dependent?.label}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        onChange={e => {
                          setSourceName(e)
                        }}
                        placeholder="Select Customer"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        styles={colourStyles}
                        value={source_name}
                        options={source_dependent?.list.map(cust => ({
                          label: cust.company,
                          value: cust.id,
                        }))}
                      />
                    </div>
                  )}
                  <div className="col-md-3 mb-3 mb-md-0">
                    <label htmlFor="">
                      Lead Type 
                    </label>
                    <Select
                      value={lead_type}
                      onChange={e => setLead_type(e)}
                      placeholder="Select Lead Type"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={type}
                    />
                  </div>
                </div>
              </Row>

              {/* Company info */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Company Information</h5>
                <div className="col-md-4 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Company Name</label>

                  <input
                    type="text"
                    placeholder="Enter Company Name"
                    className="form-control "
                    value={company_name}
                    onChange={(e) => setCompany_name(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Website</label>
                  <input
                    type="text"
                    placeholder="Enter Website"
                    className="form-control "
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Email Address</label>
                  <input
                    type="email"
                    placeholder="Enter Email Address"
                    className="form-control "
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mt-2 mb-3 mb-md-0 mt-3">
                  <label htmlFor="">Phone</label>
                  <input
                    type="text"
                    placeholder="Enter Phone"
                    className="form-control "
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
              </Row>

              {/* Address */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Address</h5>
                <div className="col-md-4 mb-3">
                  <label htmlFor="">
                    Country <span className="text-danger">*</span>{" "}
                  </label>
                  <Select
                    placeholder="Select Location"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={country_option}
                    value={country}
                    onChange={getState}
                  />
                  <span
                    className="text-danger"
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      paddingTop: "7px",
                    }}
                  >
                    {(country?.length == 0) == error
                      ? "Please select State"
                      : null}
                  </span>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="">
                    State <span className="text-danger">*</span>{" "}
                  </label>
                  <Select
                    placeholder="Select State"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={state_option}
                    value={state}
                    onChange={getCities}
                  />
                  <span
                    className="text-danger"
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      paddingTop: "7px",
                    }}
                  >
                    {(state?.length == 0) == error
                      ? "Please select State"
                      : null}
                  </span>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="">
                    City <span className="text-danger">*</span>{" "}
                  </label>
                  <Select
                    placeholder="Select City"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={city_option}
                    value={city}
                    onChange={(e) => setCity(e)}
                  />
                </div>
                <div className="col-md-8 mb-3 mt-2">
                  <label htmlFor="">Address</label>
                  <input
                    type="text"
                    placeholder="Enter Address"
                    className="form-control "
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mb-3 mt-2">
                  <label htmlFor="">Pin Code</label>
                  <input
                    type="text"
                    placeholder="Enter Pin Code"
                    className="form-control "
                    value={pincode}
                    onChange={(e) => setPinCode(e.target.value)}
                  />
                </div>

                <div className="col-12 mt-2 lead-desc">
                  <div className="d-flex justify-space-between">
                    <label htmlFor="">
                      Description <span className="text-danger">*</span>
                    </label>
                    <span
                      className="text-danger"
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        paddingTop: "7px",
                      }}
                    >
                      {(description?.length == 0) == error
                        ? "Please enter description"
                        : null}
                    </span>
                  </div>

                  <CKEditor
                    editor={ClassicEditor}
                    data={description}
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setDescription(data);
                    }}
                  />
                </div>
              </Row>

              {/* Contact */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="d-flex justify-content-between">
                  <h5 className="text-dark"> Contact</h5>
                  <div className="text-end mb-3">
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        onAddFormRow();
                      }}
                      className="btn btn-save btn-label"
                    >
                      <i className="fas fa-plus me-2 label-icon"></i>
                      Add More
                    </a>
                  </div>
                </div>
                {formRows.map((person, key) => (
                  <div key={person.id} className="mb-2">
                    <div className="d-flex">
                      <div className="contact-form d-flex gap-3 align-items-center">
                        <div className="contact-column mb-3 mb-md-0">
                          <label htmlFor="">Name</label>
                          <input
                            type="text"
                            name="person_name"
                            placeholder="Enter Name"
                            className="form-control "
                            defaultValue={person.person_name}
                            onChange={(e) => onPersonName(e, key)}
                          />
                        </div>
                        <div className="contact-column mb-3 mb-md-0">
                          <label htmlFor="">Email</label>
                          <input
                            type="text"
                            name="person_email"
                            placeholder="Enter Email"
                            className="form-control "
                            defaultValue={person.person_email}
                            onChange={(e) => onPersonEmail(e, key)}
                          />
                        </div>
                        <div className="contact-column mb-3 mb-md-0">
                          <label htmlFor="">Phone</label>
                          <input
                            type="text"
                            name="person_phone"
                            placeholder="Enter Number"
                            className="form-control "
                            defaultValue={person.person_phone}
                            onChange={(e) => onPersonPhone(e, key)}
                          />
                        </div>
                        <div className="contact-column-2 mb-3 mb-md-0 d-flex gap-3">
                          <div className="text-center">
                            <label className="d-block">Authority</label>
                            <select
                              className="form-control"
                              name="decision_maker"
                              onChange={(e) => onPersonAuthority(e, key)}
                            >
                              {options2?.map((item, i) => {
                                return (
                                  <option
                                    value={item.value}
                                    key={i}
                                    selected={
                                      item.value == person?.decision_maker
                                    }
                                  >
                                    {item.label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="text-center me-2">
                            <label className="d-block">Primary</label>
                            <select
                              className="form-control"
                              name="chk_contact"
                              onChange={(e) => onPersonPrimary(e, key)}
                            >
                              {options?.map((item, i) => {
                                return (
                                  <option
                                    value={item.value}
                                    key={i}
                                    selected={item.value == person?.chk_contact}
                                  >
                                    {item.label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="contact-btns pe-0 d-flex justify-content-end align-items-end mb-3 mb-md-0">
                        <div className="text-end">
                          {key !== 0 ? (
                            <>
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  onDeleteFormRow(key);
                                }}
                                className="btn btn-red"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </a>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 pb-10">
                      {/* <div className="col-4 mb-3 mb-md-0">
                            <label htmlFor="">Designation</label>
                            <input
                              type="text"
                              name="person_designation"
                              onChange={e => onPersonDesignation(e, key)}
                              placeholder=" Designation"
                              className="form-control "
                            />
                          </div> */}
                      <div className="col-4 mb-3 mt-2 mb-md-0">
                        <label htmlFor="">Facebook Profile Link </label>
                        <input
                          type="text"
                          name="facebook"
                          placeholder="Enter Facebook Profile Link"
                          className="form-control "
                          defaultValue={person.facebook}
                          onChange={(e) => onFacebook(e, key)}
                        />
                      </div>
                      <div className="col-4 mb-3 mt-2 mb-md-0">
                        <label htmlFor="">LinkedIn Profile Link</label>
                        <input
                          type="text"
                          name="linkedin"
                          placeholder="Enter LinkedIn Profile Link"
                          className="form-control "
                          defaultValue={person.linkedin}
                          onChange={(e) => onLinkedIn(e, key)}
                        />
                      </div>
                    </div>
                    {key !== formRows.length - 1 ? (
                      <div className="border-bottom mb-3 mt-4 "></div>
                    ) : null}
                  </div>
                ))}
              </Row>
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditLead;
